var RaphaelView = require('raphaelItemView');

/**
 * Base 'hover' shape utilized for stamps and signature notes.
 */


module.exports = RaphaelView.extend({

    hoverOpacity: 0.5,
    placedOpacity: 1,

    initialize: function(options) {

        this.options = options;

        this.ox = 0;
        this.oy = 0;

        this.note = options.note; // can now use this to listen to events
        this.paper = options.paper;
        this.channel = options.channel;
        this.originalScale = options.originalScale;

        this.listenTo( this.channel, 'hoverShape:scale', this.scale );
        this.listenTo( this, 'hoverShape:mouseMove', this.onMouseMove );
        this.listenTo( this, 'hoverShape:mouseEnterCanvas', this.show );
        this.listenTo( this, 'hoverShape:mouseExitCanvas', this.hide );

    },

    render: function() {

        this.el = this.createEl()
            .attr({
                opacity: this.getHoverOpacity()
            })
            .hide()
            .toFront();  // Ensure seen above other shapes

        return this;

    },

    createEl: $.noop,

    scale: $.noop,

    onMouseMove: $.noop,

    show: function() {
        this.el.show();
    },

    hide: function() {
        this.el.hide();
    },


    deriveShapeFromClone: function() {
        return this.el
            .clone()
            .attr( 'opacity', this.getPlacedOpacity() );
    },

    getHoverOpacity: function() {
        return this.hoverOpacity;
    },
    getPlacedOpacity: function() {
        return this.placedOpacity;
    },

    onBeforeDestroy: function() {
        this.stopListening();
        this.el.remove();
    }


});






/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/hoverShape/hoverShape.js
 ** module id = 383
 ** module chunks = 0
 **/